import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ManageContractVariable from "./components/managecontractvariable";

const ManageContractMain: React.FC<any> = (props) => {

    const [value, setValue] = React.useState('1');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <div>
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            <Tab label={<span style={{ fontFamily: "Apple_B", fontSize: "18px" }}>계약서 전송</span>} value="1" />
                            <Tab label={<span style={{ fontFamily: "Apple_B", fontSize: "18px" }}>변수 관리</span>} value="2" />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                    </TabPanel>
                    <TabPanel value="2">
                        <ManageContractVariable user={props.user} />
                    </TabPanel>
                </TabContext>
            </Box>
        </div>
    )

}

export default ManageContractMain;